import { Box, HStack, Image, Tooltip, useDisclosure } from '@chakra-ui/react';
import { BsCaretRightFill } from '@react-icons/all-files/bs/BsCaretRightFill';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';
import EnterPasswordModal from '../EnterPasswordModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var NavItem = function NavItem(_ref) {
  var _config$subMenus2;

  var children = _ref.children,
      label = _ref.label,
      endElement = _ref.endElement,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === void 0 ? 'brand' : _ref$activeColor,
      config = _ref.config,
      showSideBar = _ref.showSideBar,
      onClick = _ref.onClick;

  var _useRouter = useRouter(),
      pathname = _useRouter.pathname;

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var active = useMemo(function () {
    var _config$subMenus;

    var subLinks = (_config$subMenus = config.subMenus) === null || _config$subMenus === void 0 ? void 0 : _config$subMenus.map(function (sub) {
      return sub.link || sub.id;
    });
    return pathname === config.link || pathname === config.id || pathname === config.pathname || (subLinks === null || subLinks === void 0 ? void 0 : subLinks.includes(pathname));
  }, [config, pathname]);
  var handleClick = useCallback(function () {
    if (config.isProtected) {
      onOpen();
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  }, [config.isProtected, onClick, onOpen]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showSideBar ? /*#__PURE__*/_jsxs(HStack, {
      as: "div",
      w: "full",
      p: "2",
      cursor: "pointer",
      onClick: handleClick,
      userSelect: "none",
      rounded: "md",
      transition: "all 0.2s",
      textColor: "blackAlpha.300",
      bg: active ? activeColor : 'inherit',
      _hover: {
        bg: active ? activeColor : 'gray.50',
        textColor: active ? 'white' : 'blackAlpha.300'
      },
      _active: {
        bg: activeColor,
        textColor: 'white',
        color: 'white'
      },
      e2eid: "ShellWithGroupedMenu_NavItem_HStack",
      children: [/*#__PURE__*/_jsx(Box, {
        fontSize: "lg",
        position: "relative",
        e2eid: "ShellWithGroupedMenu_NavItem_Box",
        children: /*#__PURE__*/_jsx(Image, {
          boxSize: 6,
          alt: "icon",
          src: "/".concat(config.icon, "-").concat(active ? 'active' : 'unactive', ".svg"),
          e2eid: "ShellWithGroupedMenu_NavItem_Image"
        })
      }), showSideBar && /*#__PURE__*/_jsx(Box, {
        fontSize: "16px",
        fontWeight: "inherit",
        textColor: active ? 'white' : 'inherit',
        e2eid: "ShellWithGroupedMenu_NavItem_Box",
        children: label
      }), endElement && !children && /*#__PURE__*/_jsx(Box, {
        e2eid: "ShellWithGroupedMenu_NavItem_Box_4",
        children: endElement
      }), children && /*#__PURE__*/_jsx(Box, {
        fontSize: "xs",
        flexShrink: 0,
        as: BsCaretRightFill,
        e2eid: "ShellWithGroupedMenu_NavItem_Box_5"
      })]
    }) : /*#__PURE__*/_jsx(Tooltip, {
      label: label,
      placement: "right",
      isDisabled: !!(config !== null && config !== void 0 && (_config$subMenus2 = config.subMenus) !== null && _config$subMenus2 !== void 0 && _config$subMenus2.length),
      e2eid: "ShellWithGroupedMenu_NavItem_Tooltip",
      children: /*#__PURE__*/_jsx(HStack, {
        as: "div",
        w: "full",
        px: "3",
        py: "2",
        justify: "center",
        align: "center",
        cursor: "pointer",
        onClick: handleClick,
        userSelect: "none",
        rounded: "md",
        transition: "all 0.2s",
        color: "inherit",
        bg: active ? activeColor : 'inherit',
        _hover: {
          bg: active ? activeColor : 'gray.50',
          color: active ? 'white' : 'blackAlpha.300'
        },
        _active: {
          bg: activeColor,
          color: 'white'
        },
        e2eid: "ShellWithGroupedMenu_NavItem_HStack",
        children: /*#__PURE__*/_jsx(Box, {
          fontSize: "lg",
          position: "relative",
          e2eid: "ShellWithGroupedMenu_NavItem_Box",
          children: /*#__PURE__*/_jsx(Image, {
            boxSize: 6,
            alt: "icon",
            src: "/".concat(config.icon, "-").concat(active ? 'active' : 'unactive', ".svg"),
            e2eid: "ShellWithGroupedMenu_NavItem_Image"
          })
        })
      })
    }), isOpen && /*#__PURE__*/_jsx(EnterPasswordModal, {
      onClose: onClose,
      onSuccess: function onSuccess() {
        return window.open(config.link, '_blank');
      },
      e2eid: "ShellWithGroupedMenu_NavItem_EnterPasswordModal"
    })]
  });
};